<template>
  <keep-alive>
    <GridPage
      title="Products"
      subtitle=""
      viewset="/shop/admin/products/"
      :actions="actions"
      :filters="filters"
      :fields="fields"
      :showAddButton="true"
      :showExportButton="true"
      :showUpdateButton="true"
      :refresh="refresh"
      :ready="ready === 0"
      @addButton="handleAddButton"
      @exportButton="handleExportAllClick"
      @updateButton="handleUpdateButton"
      @rowAction="handleRowAction"
      @query="handleQuery"
    >
      <template v-slot:modals>
        <AddModal
          :show-modal="showAddModal"
          @close="handleCloseAddModal"
          @dataUpdated="handleDataUpdated"
        />
        <UpdateModal
          :show-modal="showUpdateModal"
          @close="handleCloseUpdateModal"
          @dataUpdated="handleDataUpdated"
        />
      </template>

      <template v-slot:filters>
        <DropDownCheckList
          :items="publishedFilterOptions"
          text="Published"
          icon="filter_list"
          v-model="publishedFilter"
          highlightClass="bg-light"
          class="mx-1"
          radio
        />
        <DropDownCheckList
          :items="categoryFilterOptions"
          text="Category"
          icon="filter_list"
          v-model="categoryFilter"
          highlightClass="bg-light"
          class="mx-1"
          radio
        />
        <DropDownCheckList
          v-if="collectionFilterOptions.length > 0"
          :items="collectionFilterOptions"
          text="Collection"
          icon="filter_list"
          v-model="collectionFilter"
          highlightClass="bg-light"
          class="mx-1"
          radio
        />
      </template>
    </GridPage>
  </keep-alive>
</template>

<script>
import GridPage from "@/components/layout/Page/GridPage.vue";
import DropDownCheckList from "@/components/DropDownChecklist.vue";

import AddModal from "./AddModal";
import UpdateModal from "./UpdateModal";

import formatters from "@/components/DataGrid/formatters";

export default {
  name: "odd-view-products-main",
  data() {
    return {
      showAddModal: false,
      showUpdateModal: false,
      editPK: null,
      publishedFilterOptions: [
        { name: "", title: "Show All" },
        { name: "1", title: "Published Only" },
        { name: "0", title: "Unpublished Only" }
      ],
      publishedFilter: "1",
      categoryFilter: "",
      collectionFilter: "",
      refresh: 0,
      ready: 0,
      actions: [
        {
          name: "Unpublish",
          icon: "call_received",
          theme: "danger",
          event: "unpublish",
          condition(rowData) {
            return rowData.published;
          }
        },
        {
          name: "Publish",
          icon: "call_made",
          theme: "success",
          event: "publish",
          condition(rowData) {
            return !rowData.published;
          }
        },
        {
          name: "Duplicate",
          icon: "content_copy",
          theme: "dark",
          event: "duplicate"
        },
        {
          name: "Edit",
          icon: "edit",
          event: "edit"
        }
      ],
      fields: [
        {
          name: "key",
          title: "Key",
          sortField: "key",
          visible: false
        },
        {
          name: "name",
          title: "Name",
          sortField: "name",
          formatter: formatters.product.name,
          visible: true
        },
        {
          name: "base_price",
          title: "Base Price",
          sortField: "base_price",
          formatter: formatters.currency.usd,
          visible: true
        },
        {
          name: "tax_rate",
          title: "Tax Rate",
          sortField: "tax_rate",
          visible: false
        },
        {
          name: "categories",
          title: "Categories",
          sortField: "categories__name",
          formatter: formatters.productCategories.asList,
          visible: true
        },
        {
          name: "created",
          title: "Created",
          sortField: "created",
          formatter: formatters.datetime.withSubtext,
          visible: false
        },
        {
          name: "updated",
          title: "Last Updated",
          sortField: "updated",
          formatter: formatters.datetime.withSubtext,
          visible: true
        },
        {
          name: "published",
          title: "Published",
          sortField: "published",
          formatter: formatters.boolean.checkmark,
          align: "center",
          visible: true
        }
      ],
      query: ""
    };
  },
  computed: {
    filters() {
      return {
        published: this.publishedFilter,
        categories: this.categoryFilter,
        collections: this.collectionFilter
      };
    },
    categoryFilterOptions() {
      if (
        !!this.$store.state.productCategories.list &&
        !!this.$store.state.productCategories.list["results"]
      ) {
        return this.$store.state.productCategories.list.results.map(cat => {
          return { name: cat.id, title: cat.name };
        });
      }
      return [];
    },
    collectionFilterOptions() {
      return this.$store.state.productCollections.list.map(cat => {
        return { name: cat.id, title: cat.name };
      });
    }
  },
  components: {
    GridPage,
    AddModal,
    UpdateModal,
    DropDownCheckList
  },
  methods: {
    handleRowAction(data) {
      if (data.action.event === "publish") {
        this.$store
          .dispatch("products/update", {
            key: data.props.rowData.key,
            published: true
          })
          .then(() => {
            this.handleDataUpdated();
          });
      }
      if (data.action.event === "unpublish") {
        this.$store
          .dispatch("products/update", {
            key: data.props.rowData.key,
            published: false
          })
          .then(() => {
            this.handleDataUpdated();
          });
      }
      if (data.action.event === "edit") {
        this.$router.push({
          name: "products__edit",
          params: { key: data.props.rowData.key }
        });
      }
      if (data.action.event === "duplicate") {
        this.$store
          .dispatch("products/duplicate", {
            key: data.props.rowData.key
          })
          .then((product) => {
            this.$router.push({
              name: "products__edit",
              params: { key: product.key }
            });
          });
      }
    },
    handleAddButton(event) {
      this.showAddModal = true;
    },
    handleCloseAddModal(event) {
      this.showAddModal = false;
    },
    handleUpdateButton(event) {
      this.showUpdateModal = true;
    },
    handleCloseUpdateModal(updated) {
      this.showUpdateModal = false;
      if (updated) {
        this.handleDataUpdated();
      }
    },
    handleDataUpdated(event) {
      this.refresh = this.refresh + 1;
    },
    handleExportAllClick(event) {
      this.$store.dispatch("products/export", this.query).then(data => {
        console.log(data);
      });
    },
    handleQuery(query) {
      this.query = query;
    }
  },
  created() {
    this.ready = this.ready + 1;
    this.$store.dispatch("productCategories/init").then(() => {
      this.ready = this.ready - 1;
    });
  },
  activated() {
    this.handleDataUpdated();
  }
};
</script>
